import React from 'react';
import PropTypes from 'prop-types';
import { Button, SvgIcon } from '@mui/material';
import { RadioButtonUnchecked as RadioButtonUncheckedIcon } from '@mui/icons-material';
import CheckCircleIcon from '../../../../../icons/check-circle.svg?react';
import './AdditionalBenifitsInput.scss';

export default function AdditionalBenifitsInput(props) {

    return (
        <Button
            variant={props.value ? 'outlined' : 'contained'}
            className={`shadow benifits-card-input ${props.value ? `'active button-active-border` : 'inactive'} ${props.mobileWide ? 'wide-sm' : ''}`}
            onClick={props.onClick}
            aria-pressed={props.value}
            aria-labelledby={props.title}
        // color="primary"
        >
            <span className='benefits-card-span w-100'>
                <div className="heading-wrapper">
                    <span className='title primary-color'>{props.title}</span>
                    <span className='additional-premium primary-color'><span className="text">Additional</span><span><sup>$</sup><b>{props.premium}</b>/mo</span></span>
                </div>
                <ul>
                    {props.benifits.map((data, index) => {
                        return (
                            <li key={index}><span className='list-title'>{data.title}<span className='primary-color'>{" "}{data.amount}</span></span></li>
                        )
                    })}
                </ul>
                {props.value ? (
                    <SvgIcon component={CheckCircleIcon} color="primary" name={props.productName} className="check" />
                ) : (
                    <SvgIcon component={RadioButtonUncheckedIcon} color="disabled" className="unCheck" />
                )}
            </span>
        </Button>
    );
}

AdditionalBenifitsInput.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    mobileWide: PropTypes.bool,
};
